import { Award, Coins, Sparkles, Trophy } from 'lucide-react';

export default function CreditsPage() {
  const rewards = [
    {
      points: 1000,
      title: 'PlayStation 5',
      description: 'Ekte lojalitet betaler seg. Samle 1000 VærCoins og få en splitter ny PS5.',
      tone: 'ps5' as const,
      image: 'https://upload.wikimedia.org/wikipedia/commons/7/7e/PlayStation_logo_and_wordmark_%28cropped%29.svg',
    },
    { points: 125, title: 'Gjesdalivery Caps', description: 'Kul caps med vårt logo', tone: 'blue' as const },
    { points: 250, title: 'Caps + T-skjorte', description: 'Caps og t-skjorte pakke', tone: 'orange' as const },
    { points: 500, title: 'Hoodie Pack', description: 'Full pakke med hoodie, caps og t-skjorte', tone: 'green' as const },
  ];

  return (
    <div className="min-h-screen bg-gray-50 text-gray-900 dark:bg-[#0f1724] dark:text-white transition-colors">
      <div className="max-w-5xl mx-auto px-6 py-16">

        {/* HERO */}
        <div className="text-center rounded-[2rem] border border-white/10 bg-white/85 dark:bg-[#121b2e]/95 backdrop-blur-md shadow-[0_10px_40px_rgba(0,0,0,.12)] dark:shadow-[0_10px_40px_rgba(0,0,0,.35)] p-10 md:p-14 mb-10">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-gradient-to-br from-[#004D99] to-orange-500 mb-6">
            <Coins className="w-10 h-10 text-white" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold tracking-tight">VærCoins</h1>
          <p className="mt-4 text-lg md:text-xl text-gray-700 dark:text-white/75 max-w-2xl mx-auto">
            Tjen 1% av hver ordre som VærCoins. Bytt dem inn i merch, mat, og for de dedikerte — en PS5.
          </p>
        </div>

        {/* PS5 SUPERPREMIE */}
        <section className="mb-14">
          <div className="relative overflow-hidden rounded-2xl border border-gray-200 dark:border-white/10 bg-white/85 dark:bg-[#121b2e]/95 shadow-lg p-8 flex flex-col md:flex-row items-center justify-between gap-10">
            <div className="flex-1 text-center md:text-left">
              <span className="inline-flex items-center gap-2 rounded-full border border-gray-300/70 bg-white/80 px-3 py-1 text-xs text-gray-700 backdrop-blur-sm dark:border-white/10 dark:bg-white/5 dark:text-white/80">
                <Sparkles className="h-4 w-4 text-orange-400" /> Superpremie
              </span>

              <h2 className="mt-4 text-3xl md:text-4xl font-bold">Få en PlayStation 5</h2>
              <p className="mt-3 text-gray-700 dark:text-white/75 max-w-lg">
                1000 VærCoins, så kan du oppleve neste nivå console-gaming.
              </p>

              <ul className="mt-4 space-y-2 text-sm text-gray-700 dark:text-white/70">
                <li>• 1 VærCoin per 100 kr ordre</li>
                <li>• 1000 VærCoins = PS5</li>
                <li>• Begrenset antall per person!</li>
              </ul>

              <div className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#004D99] px-6 py-3 text-white font-semibold shadow hover:bg-[#003366] transition">
                <Trophy className="h-5 w-5" />
                Samle 1000 VærCoins å lås opp PS5!
              </div>
            </div>

            <div className="w-48 md:w-64 flex-shrink-0 relative">
              <div className="absolute inset-0 blur-3xl bg-orange-500/20 rounded-full -z-10" />
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/7/7e/PlayStation_logo_and_wordmark_%28cropped%29.svg"
                alt="PlayStation 5 logo"
                className="w-full object-contain"
              />
            </div>
          </div>
        </section>

        {/* HVORDAN DET FUNGERER */}
        <section className="mb-14">
          <div className="rounded-2xl border border-gray-200 dark:border-white/10 bg-white/85 dark:bg-[#121b2e]/95 shadow-sm overflow-hidden">
            <div className="px-6 py-5 border-b border-gray-200/70 dark:border-white/10 text-center">
              <h2 className="text-lg md:text-xl font-semibold">Sånn fungerer det</h2>
            </div>
            <div className="px-6 py-8">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
                <StepBlock n={1} text="Bestill mat eller dagligvarer fra Gjesdalivery" />
                <StepBlock n={2} text="Tjen 1% av ordretotalen som VærCoins" />
                <StepBlock n={3} text="Bytt inn VærCoins mot premier – eller spar til PS5" />
              </div>
            </div>
            <div className="px-6 py-5 border-t border-gray-200/70 dark:border-white/10 text-center">
              <p className="text-sm md:text-base">
                <span className="opacity-80">Eksempel:</span>{' '}
                <span className="opacity-80">Sum 200 kr</span>{' '}
                <span className="opacity-60">→</span>{' '}
                <span className="font-semibold text-[#004D99] dark:text-orange-400">
                  Poeng tjent: 2 VærCoins
                </span>
              </p>
            </div>
          </div>
        </section>

        {/* PREMIER */}
        <section>
          <h2 className="text-2xl md:text-3xl font-semibold text-center mb-8">Andre premier</h2>
          <div className="space-y-6">
            {rewards
              .filter((r) => r.tone !== 'ps5')
              .map((r) => (
                <RewardCard key={r.points} {...r} />
              ))}
          </div>
        </section>

        {/* TIPS */}
        <section className="mt-12">
          <div className="rounded-2xl border border-gray-200 dark:border-white/10 bg-white/85 dark:bg-[#121b2e]/95 p-6">
            <h3 className="text-xl font-semibold mb-2">Tips for å tjene VærCoins raskere</h3>
            <ul className="space-y-2 text-gray-700 dark:text-white/75">
              <li>• Bestill regelmessig — større ordre gir flere VærCoins.</li>
              <li>• Del med venner — jo flere som bruker Gjesdalivery, jo bedre.</li>
              <li>• Følg med på kampanjer der du kan tjene ekstra VærCoins.</li>
            </ul>
          </div>
        </section>
      </div>
    </div>
  );
}

/* ——— små komponenter ——— */

function StepBlock({ n, text }: { n: number; text: string }) {
  return (
    <div className="flex flex-col items-center">
      <div className="text-3xl md:text-4xl font-bold text-[#004D99] dark:text-orange-400 mb-2">{n}</div>
      <p className="text-sm md:text-base leading-relaxed text-gray-700 dark:text-white/75 max-w-xs">{text}</p>
    </div>
  );
}

function RewardCard({
  title,
  description,
  points,
  tone,
}: {
  title: string;
  description: string;
  points: number;
  tone: 'blue' | 'orange' | 'green';
}) {
  const tones = {
    blue: {
      chipBg: 'bg-blue-50 dark:bg-white/10',
      chipText: 'text-[#004D99] dark:text-blue-300',
      iconText: 'text-[#004D99] dark:text-blue-300',
    },
    orange: {
      chipBg: 'bg-orange-50 dark:bg-white/10',
      chipText: 'text-orange-600 dark:text-orange-300',
      iconText: 'text-orange-600 dark:text-orange-300',
    },
    green: {
      chipBg: 'bg-green-50 dark:bg-white/10',
      chipText: 'text-green-600 dark:text-green-300',
      iconText: 'text-green-600 dark:text-green-300',
    },
  }[tone];

  return (
    <div className="rounded-2xl border border-gray-200 dark:border-white/10 bg-white/85 dark:bg-[#121b2e]/95 p-6 shadow-sm">
      <div className="flex items-center gap-5">
        <div className="flex-shrink-0 w-16 h-16 rounded-xl bg-white/70 dark:bg-white/10 flex items-center justify-center">
          <Award className={`w-9 h-9 ${tones.iconText}`} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-3 flex-wrap">
            <h3 className="text-xl font-semibold truncate">{title}</h3>
            <span className={`px-3 py-1 rounded-full text-sm font-semibold ${tones.chipBg} ${tones.chipText}`}>
              {points} VærCoins
            </span>
          </div>
          <p className="mt-1 text-gray-700 dark:text-white/70">{description}</p>
        </div>
      </div>
    </div>
  );
}
